import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Error from "./Ecommerce_Advance/Error";
import Home from "./Ecommerce_Advance/Home";
import About from "./Ecommerce_Advance/About";
import Products from "./Ecommerce_Advance/Products";
import Contact from "./Ecommerce_Advance/Contact";
import SingleProduct from "./Ecommerce_Advance/SingleProduct";
import { ThemeProvider } from "styled-components";

import Cart1 from "./Ecommerce_Advance/Cart";

import { GlobalStyle } from "./Ecommerce_Advance/GlobalStyle";
import Footer from "./components/Footer";

const App = () => {
  // const { productData, initialise } = useContext(ApiContext);
  const theme = {
    colors: {
      heading: "rgb(24 24 29)",
      text: "rgba(29 ,29, 29, .8)",
      white: "#fff",
      black: " #212529",
      helper: "#8490ff",

      bg: "#F6F8FA",
      footer_bg: "#0a1435",
      btn: "rgb(98 84 243)",
      border: "rgba(98, 84, 243, 0.5)",
      hr: "#ffffff",
      gradient:
        "linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
    },
    media: {
      mobile: "768px",
      tab: "998px",
    },
  };
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Router>
          <GlobalStyle />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cart" element={<Cart1 />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/singleproduct/:id" element={<SingleProduct />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </Router>
        <Footer />
      </ThemeProvider>
    </div>
  );
};

export default App;
